import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import KronosCodeForm from '@/components/admin/admin-components/config/forms/KronosCodeForm.vue';
import KronosLicenseForm from '@/components/admin/admin-components/config/forms/KronosLicenseForm.vue';
import KronosRegionForm from '@/components/admin/admin-components/config/forms/KronosRegionForm.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'KronosFormWrapper',
    props: {
        selectedItem: {}
    },
    emits: ["close-modal", "refresh-config"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const formComponent = computed(() => {
            const formType = props.selectedItem?.formType ?? 'kronosRegion';
            switch (formType) {
                case 'kronosCode':
                    return KronosCodeForm;
                case 'kronosLicense':
                    return KronosLicenseForm;
                case 'kronosRegion':
                default:
                    return KronosRegionForm;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(formComponent.value), {
                "selected-item": _ctx.selectedItem?.configData,
                onCloseModal: _cache[0] || (_cache[0] = ($event) => (emit('close-modal'))),
                onRefreshConfig: _cache[1] || (_cache[1] = ($event) => (emit('refresh-config')))
            }, null, 40, ["selected-item"]));
        };
    }
});
